import { z } from 'zod';
import { College } from '../user/enums';

export const ReminderContentSchema = z.object({
    title: z.string().min(1),
    body: z.string().min(1),
});

export type ReminderContent = z.infer<typeof ReminderContentSchema>;

export const NotificationConfigSchema = z.object({
    id: z.string(),
    remindersEnabled: z.boolean(),
    cronExpression: z.string(),
    cronDescription: z.string(),
    useCustomReminderContent: z.boolean(),
    customQuizReminder: ReminderContentSchema.optional(),
    customArticleReminder: ReminderContentSchema.optional(),
});

export type NotificationConfig = z.infer<typeof NotificationConfigSchema>;

export const CustomNotificationSchema = z.object({
    id: z.string(),
    title: z.string(),
    body: z.string(),
    targetColleges: z.array(z.nativeEnum(College)),
    createdAt: z.string().or(z.date()),
    updatedAt: z.string().or(z.date()),
});

export type CustomNotification = z.infer<typeof CustomNotificationSchema>;

export const DEFAULT_QUIZ_REMINDER = {
    title: 'You have quizzes waiting!',
    body: 'Complete your quizzes to unlock personalized articles and resources tailored just for you.',
} as const satisfies ReminderContent;

export const DEFAULT_ARTICLE_REMINDER = {
    title: 'New resources available for you!',
    body: "Check out the articles and resources based on your quiz results. There's something new waiting for you.",
} as const satisfies ReminderContent;
